import { Card, Flex, Typography } from 'antd'
import { t } from 'i18next'
import React, { useContext } from 'react'
import { Color } from '../../../Common/Color'
import SpecialistContext from '../SpecialistContext'

export default function SpecialistAppointments ({ displayAppointments, width }) {
  const { appointments, day } = useContext(SpecialistContext)

  return (
    <Flex vertical style={{ maxWidth: width }}>
      <Typography.Title level={2} style={{ margin: '2em 0 1em 0', textAlign: 'center' }}>{t('Public.Specialist.appointmentsAvailable')}</Typography.Title>
      <Card title={<Typography.Title level={4} style={{ color: Color.white }}>{day?.format('D MMMM YYYY')}</Typography.Title>}
        variant='borderless'
        styles={{
          body: { textAlign: 'center', height: '28.5em', overflowY: 'scroll' },
          header: { textAlign: 'center', backgroundColor: Color.green }
        }}
        style={{ width: '-webkit-fill-available', boxShadow: '1px 1px 10px #4f5d75' }}
      >
        { displayAppointments(appointments) }
      </Card>
    </Flex>
  )
}
